import React, { forwardRef, useMemo, useState, useCallback } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import NonameMappingForm from './NonameMappingForm';
import { Alert } from 'antd';
import { isUndefined } from 'lodash';


function NonameCredentialsForm(props, ref) {
    const isEdit = !isUndefined(props.config);
    const [authType, setAuthType] = useState((isEdit && props.config.isServiceAccount === "false") ? "token" : "service");
    
    const onRadioChange = useCallback((e) => {
        setAuthType(e.target.value);
    }, []);

    const fields = useMemo(() => [
        {
            name: "apiEndPoint",
            label: "API EndPoint",
            required: true,
            rules: [urlRegexValidator]
        },
        ...(props.config?.isServiceAccount === "false"
            ?
            [{
                name: "loginType",
                type: FieldTypes.RADIO,
                options: [{ label: 'Service Account (Recommended)', value: 'service' }, { label: 'Token', value: 'token' }],
                props: {
                    onChange: onRadioChange,
                    defaultValue: authType,
                }
            }] : []),
        ...(authType === 'service'
            ?
            [{
                name: "clientId",
                label: "Client ID",
                required: true,
            },
            {
                name: "clientSecret",
                label: "Client Secret",
                required: true,
                type: FieldTypes.PASSWORD,
            }] :
            [{
                name: "token",
                label: "Token",
                required: true,
                type: FieldTypes.PASSWORD,
            }]),
        {
            name: "message",
            type: FieldTypes.LABEL,
            value: <Alert type='warning' message="Projects take a few minutes to appear in the system after you add the credentials." />
        }
    ], [authType, onRadioChange, props.config]);

    const beforeSave = useCallback((data) => {
        if(isUndefined(data.loginType)){
            data.loginType = !isUndefined(data.clientId) ? "service" : "token";
        } 
        data.isServiceAccount = data.loginType === "service" ? true : false;
        delete data.loginType;
        return data;
    }, []);

    return (
        <GenericPullCredentialsForm
            {...props}
            initialValue={isEdit ? { ...props.config } : { loginType: 'service' }}
            ref={ref}
            fields={fields}
            versionField={false}
            MappingForm={NonameMappingForm}
            beforeSave={beforeSave}
        />
    )
}

export default forwardRef(NonameCredentialsForm);